import { ImageBackgroundColors, mtc } from '../../../utils/style-helpers'
import { containerStyles, imageSizes } from './styles'

export type IllustrationBlockSize = 'sm' | 'md' | 'lg'

export interface IllustrationBlockProps {
  /** Illustration image URL */
  src: string
  /** Alt text for the illustration */
  alt: string
  /** Size variant controlling illustration dimensions and padding */
  size?: IllustrationBlockSize
  /** Background color of the block */
  color?: ImageBackgroundColors
  /** Additional classes for the wrapper (e.g. to control width) */
  className?: string
}

export const IllustrationBlock = ({
  src,
  alt,
  size = 'md',
  color = ImageBackgroundColors.GREEN,
  className,
}: IllustrationBlockProps) => {
  return (
    <div className={mtc(containerStyles({ size }), color, className)}>
      <img
        src={src}
        alt={alt}
        className={mtc('object-contain', imageSizes[size])}
        loading="lazy"
      />
    </div>
  )
}

IllustrationBlock.displayName = 'IllustrationBlock'
